import { EmLogoIcon } from '@/icons/logo';
import { BlurFade } from "@/components/ui/blur-fade";
interface EmptyStateProps {
  onAddClick: () => void;
  onImportClick?: () => void;
}

export function EmptyState({ onAddClick, onImportClick }: EmptyStateProps) {
  return (
    <div className="flex justify-center items-center pt-10 sm:pt-20">
      <div className="p-2 sm:p-3 max-w-lg mx-auto text-[15px]/6 text-left font-sans  space-y-0">
        <BlurFade delay={0.2}>
          <h2 className=" sm:text-[#edecec] tracking-tight">
            BookmarkBloom
          </h2>
        </BlurFade>
        <BlurFade delay={0.2}>
          <p className="text-gray-500 sm:text-[#edecec]/60 font-pixel text-xs">
            {">>"} WELCOME TO BOOKMARK BLOOM {"<<"}
          </p>
        </BlurFade>
        <BlurFade delay={0.3}>
          <p className="text-gray-500 sm:text-[#edecec]/60">
            Your retro-style link manager. Keyboard shortcuts, auto-metadata, zero bloat. Built for speed, designed for simplicity.
          </p>
        </BlurFade>
        <BlurFade delay={0.4}>
          <h2 className="mt-5 tracking-wider sm:text-[#edecec] font-pixel text-xs">
            FEATURES
          </h2>
        </BlurFade>
        <BlurFade delay={0.45}>
          <p className="text-gray-500 sm:text-[#edecec]/60">
            ⚡ Lightning fast loading<br/>
            ⌨️ Keyboard-first navigation<br/>
            🔍 Smart search & auto-complete<br/>
            🛡️ Privacy by default<br/>
            🎮 Retro pixel aesthetics
          </p>
        </BlurFade>
        <BlurFade delay={0.5}>
          <h2 className="mt-5 tracking-wider sm:text-[#edecec] font-pixel text-xs">
            PRIVACY
          </h2>
        </BlurFade>
        <BlurFade delay={0.55}>
          <p className="text-gray-500 sm:text-[#edecec]/60">
            All data stays in your browser. No servers, no tracking, no ads. Complete control over your digital garden.
          </p>
        </BlurFade>
        <BlurFade delay={0.55}>
          <div className="flex items-center gap-3 mt-8">
            <button
              onClick={onAddClick}
              className="cursor-pointer sm:text-[#edecec] sm:hover:opacity-80 transition-all duration-300 underline underline-offset-4 font-pixel text-xs"
            >
              [START BLOOMING]
            </button>
            {onImportClick && (
              <>
                <span className="text-gray-300 sm:text-[#edecec]/20">/</span>
                <button
                  onClick={onImportClick}
                  className="cursor-pointer  sm:text-[#edecec] sm:hover:opacity-80 transition-all duration-300 underline underline-offset-4 font-pixel text-xs"
                >
                  [IMPORT]
                </button>
              </>
            )}
          </div>
        </BlurFade>
        <BlurFade delay={0.6}>
          <p className="sm:text-[#edecec]/60 text-[10px] mt-8 pt-4 border-t border-gray-200 flex items-center justify-between">
            <span>
              Inspired by{' '}
              <a 
                href="https://bmrks.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="underline hover:text-white transition-colors"
              >
                Rauno's Bookmarks
              </a>
            </span>
            <a 
              href="https://nishantdev.space" 
              target="_blank" 
              rel="noopener noreferrer"
              className="cursor-pointer"
            >
              <EmLogoIcon className='duration-300 transition-colors size-4 sm:size-6 fill-black sm:fill-[#edecec]/60 sm:hover:fill-white'/>
            </a>
          </p>
        </BlurFade>
      </div>
    </div>
  );
}
